// i18n area 'auth' — locale no-NO (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.no-NO.meta.json.
import type { enUS } from './auth'

export const noNO: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Logg inn på kontoen din',
    username: 'Brukernavn',
    usernamePlaceholder: 'Skriv inn brukernavnet',
    usernameHint: 'Bruk bruker@domene for å autentisere deg mot et directory-realm',
    continue: 'Fortsett',
    changeUser: 'Ikke deg?',
    password: 'Passord',
    forgotPassword: 'Glemt passordet?',
    submit: 'Logg inn',
    otp: 'Engangskode',
    otpSubtitle: 'Skriv inn koden fra autentikatoren din',
    otpHint: 'Seks sifre fra autentiseringsappen, eller en av gjenopprettingskodene',
    otpSubmit: 'Verifiser',
    invalidCredentials: 'Ugyldig brukernavn eller passord',
    tooManyAttempts: 'For mange forsøk — vent et øyeblikk og prøv igjen',
    realmUnavailable: 'Realmet kan ikke verifisere legitimasjonen akkurat nå — klusterets store er ikke tilgjengelig. Logg inn som lokal bruker (break-glass).',
    genericError: 'Innloggingen mislyktes — er TVirt-backenden tilgjengelig?'
  },
  user: {
    logout: 'Logg ut',
    password: {
      menu: 'Bytt passord',
      title: 'Bytt passordet ditt',
      current: 'Nåværende passord',
      new: 'Nytt passord',
      confirm: 'Bekreft nytt passord',
      mismatch: 'Passordene stemmer ikke overens',
      error: 'Kunne ikke bytte passordet',
      forcedTitle: 'Bytt passordet for å fortsette',
      forcedHint: 'Dette passordet ble satt av en administrator og må erstattes før du kommer inn.',
      forcedSubmit: 'Bytt og logg inn'
    },
    mfa: {
      title: 'Tofaktorautentisering',
      subtitle: 'En andre faktor kreves ved hver innlogging',
      loadError: 'Kunne ikke laste statusen til den andre faktoren',
      enrolled: 'Aktiv',
      notEnrolled: 'Ikke aktiv',
      enrolledAt: 'Aktivert den',
      codesRemaining: 'Gjenværende gjenopprettingskoder',
      requiredHint:
        'En administrator krever andre faktor på denne kontoen: konfigurer den nå — til du gjør det kan du logge inn, men lite annet.',
      enroll: 'Konfigurer',
      enrollTitle: 'Konfigurer tofaktorautentiseringen',
      enrollHint: 'Skann denne koden med autentiseringsappen, og tast så koden den viser for å bekrefte.',
      secretHint: 'Får du ikke skannet den? Tast denne hemmeligheten i appen:',
      code: 'Kode fra appen',
      confirm: 'Bekreft',
      startError: 'Kunne ikke starte konfigurasjonen',
      confirmError: 'Kunne ikke bekrefte konfigurasjonen',
      codesTitle: 'Gjenopprettingskodene dine',
      codesWarning:
        'Disse kodene vises bare én gang. Lagre dem nå: hver av dem logger deg inn når autentikatoren ikke er tilgjengelig, og gjelder bare én gang.',
      codesAck: 'Jeg har lagret gjenopprettingskodene',
      codesDone: 'Ferdig',
      copy: 'Kopier',
      copied: 'Kopiert',
      download: 'Last ned',
      regenerate: 'Nye gjenopprettingskoder',
      regenerateTitle: 'Regenerer gjenopprettingskodene',
      regenerateHint: 'Alle kodene utstedt så langt slutter å virke i det øyeblikket det nye settet genereres.',
      regenerateConfirm: 'Regenerer',
      regenerateError: 'Kunne ikke regenerere gjenopprettingskodene',
      remove: 'Fjern',
      removeTitle: 'Fjern den andre faktoren',
      removeConfirm: 'Fjern',
      removeHint: 'Kontoen går tilbake til bare passord. Du kan konfigurere den andre faktoren igjen når du vil.',
      removeRequiredHint:
        'En administrator krever andre faktor på denne kontoen, så serveren vil avvise fjerningen — be om at påbudet fjernes først.',
      removeError: 'Kunne ikke fjerne den andre faktoren'
    },
    profile: {
      menu: 'Gå til profilen min',
      sessions: 'Aktive sesjoner',
      sessionsHint: 'De åpne sesjonene dine på denne noden',
      sessionsEmpty: 'Ingen aktiv sesjon',
      sessionCreated: 'Logget inn',
      sessionExpires: 'Utløper',
      revoke: 'Tilbakekall sesjon',
      revokeError: 'Kunne ikke tilbakekalle sesjonen',
      loadError: 'Kunne ikke laste sesjonene'
    }
  }
}
